import styled from 'styled-components';
import { GalleryArrow } from '@lt/components/icons-react';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;

  .swiper-container::after {
    content: '';
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
    position: absolute;
    width: 48px;
    height: 100%;
    right: 0;
    top: 0;
    z-index: 1;
  }
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const Arrow = styled(GalleryArrow).attrs({ stroke: '#17181A' })`
  &.swiper-button-disabled {
    display: none;
  }

  && {
    position: absolute;
    cursor: pointer;
    height: 70px;
    width: 30px;
    z-index: 10;
    top: calc(50% - 35px);
    left: ${(props) => (props.type === 'prev' ? 0 : 'auto')};
    right: ${(props) => (props.type === 'next' ? 0 : 'auto')};
    transform: rotate(${(props) => (props.type === 'prev' ? '180deg' : '0deg')});
    transition: opacity 0.15s ease-in-out;
  }
`;
